export namespace SearchType {
  export const All = 'all'
  export const Processes = 'processes'
  export const AtrContracts = 'atrContracts'
  export const Bills = 'bills'

  export const list = [All, Processes, AtrContracts, Bills]
}